"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const codegen_1 = require("../../compile/codegen");
const error = {
  message(_ref) {
    let {
      keyword,
      schemaCode
    } = _ref;
    const comp = keyword === "maxProperties" ? "more" : "fewer";
    return (0, codegen_1.str)`must NOT have ${comp} than ${schemaCode} properties`;
  },
  params: _ref2 => {
    let {
      schemaCode
    } = _ref2;
    return (0, codegen_1._)`{limit: ${schemaCode}}`;
  }
};
const def = {
  keyword: ["maxProperties", "minProperties"],
  type: "object",
  schemaType: "number",
  $data: true,
  error,
  code(cxt) {
    const {
      keyword,
      data,
      schemaCode
    } = cxt;
    const op = keyword === "maxProperties" ? codegen_1.operators.GT : codegen_1.operators.LT;
    cxt.fail$data((0, codegen_1._)`Object.keys(${data}).length ${op} ${schemaCode}`);
  }
};
exports.default = def;